import { render, staticRenderFns } from "./untranscribable-image-gray.svg?vue&type=template&id=5fe4bbb5"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports